import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import {UsageSummary} from "../apiConfigs"

export const UsageSummaryApi = createAsyncThunk(
    'auth/analytics/UsageSummaryApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(UsageSummary, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const UsageSummarySlice = createSlice({
    name: 'analytics/UsageSummaryApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(UsageSummaryApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(UsageSummaryApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.results
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(UsageSummaryApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const UsageSummaryReducer = UsageSummarySlice.reducer


